var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-carousel',{attrs:{"autoplay":""}},_vm._l((_vm.reportData),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isRunning),expression:"item.isRunning"}],key:index,on:{"click":function($event){return _vm.jumpUrl(item)}}},[_c('h3',[_c('span',{style:({
          backgroundImage: 'url(' + item.banner_img_url + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        })})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }